import {KpiRangeBreachSeverity} from '@hconnect/common/types'
import {KpiThresholdIcon} from '@widgets/kpis'
import {TFunction} from 'i18next'
import React from 'react'

import {ThresholdsData, ThresholdsName} from '../types'

import {ThresholdsConfig} from '@settings/modules/common/components'
import {ThresholdSign} from '@settings/modules/common/types'

export type KpiThresholdsConfig = ThresholdsConfig<ThresholdsData, KpiRangeBreachSeverity>

export const getKpiThresholdsConfig = (
  t: TFunction,
  unit: string | null
): KpiThresholdsConfig[] => [
  {
    label: t('kpiCalculationSettings.label.highHigh'),
    valueName: `thresholds.${ThresholdsName.HighHigh}.value`,
    statusName: `thresholds.${ThresholdsName.HighHigh}.severity`,
    defaultStatus: KpiRangeBreachSeverity.Alarm,
    unit,
    sign: ThresholdSign.MoreThan
  },
  {
    label: t('kpiCalculationSettings.label.high'),
    valueName: `thresholds.${ThresholdsName.High}.value`,
    statusName: `thresholds.${ThresholdsName.High}.severity`,
    defaultStatus: KpiRangeBreachSeverity.Warning,
    unit,
    sign: ThresholdSign.MoreThan
  },
  {
    label: t('kpiCalculationSettings.label.low'),
    valueName: `thresholds.${ThresholdsName.Low}.value`,
    statusName: `thresholds.${ThresholdsName.Low}.severity`,
    defaultStatus: KpiRangeBreachSeverity.Warning,
    unit,
    sign: ThresholdSign.LessThan
  },
  {
    label: t('kpiCalculationSettings.label.lowLow'),
    valueName: `thresholds.${ThresholdsName.LowLow}.value`,
    statusName: `thresholds.${ThresholdsName.LowLow}.severity`,
    defaultStatus: KpiRangeBreachSeverity.Alarm,
    unit,
    sign: ThresholdSign.LessThan
  }
]

export const getThresholdSeverityOptions = (t: TFunction) => [
  {
    value: KpiRangeBreachSeverity.Alarm,
    label: t('thresholdTable.label.alarm'),
    Icon: <KpiThresholdIcon status={KpiRangeBreachSeverity.Alarm} />
  },
  {
    value: KpiRangeBreachSeverity.Warning,
    label: t('thresholdTable.label.warning'),
    Icon: <KpiThresholdIcon status={KpiRangeBreachSeverity.Warning} />
  }
]
